var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdvanced = function SvgAdvanced(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 13.89c0 1.136-.84 2.11-2.073 2.11H3.08C1.84 16 1 15.026 1 13.89c0-.353.09-.706.272-1.036L7.203 2.09C7.604 1.36 8.3 1 9.003 1s1.393.345 1.794 1.09l5.93 10.764c.182.33.273.683.273 1.036M8.92 5.003c-.57.04-.99.54-.94 1.11l.3 3.737c.03.35.3.62.65.65h.06c.37 0 .68-.28.71-.65l.34-3.737v-.16a1.06 1.06 0 0 0-1.12-.95M10 12.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdvanced);
export { ForwardRef as Icon };
export default "img/element-icons/room/settings/advanced.741b3a1.svg";